import styled from 'styled-components';

import { ModalHeading } from 'components/modal';

export const StyledModalHeader = styled(ModalHeading)<{ $deliveryOnSameScreen?: boolean }>`
  margin: 0 auto;
  font-size: ${props => (props.$deliveryOnSameScreen ? '1.85rem' : '2.25rem')};
  max-width: 100%;
  white-space: normal;
  margin-block-start: ${props => (props.$deliveryOnSameScreen ? '1.5rem' : '0')};
`;

/**
 * Adjust padding of sub components.
 * Normally this is done by ModalContent from 'components/modal'
 * However, delivery-addresses has a full-width style on address list
 * so this style needs to be applied more granularly
 */
export const ModalContent = styled.div<{ $deliveryOnSameScreen?: boolean }>`
  width: ${props => (props.$deliveryOnSameScreen ? '100%' : 'calc(100% - 4.75rem)')};
  height: ${props => (props.$deliveryOnSameScreen ? '75vh' : 'auto')};
  display: ${props => (props.$deliveryOnSameScreen ? 'flex' : 'block')};
  flex-wrap: wrap;
  margin: 0 auto;
`;

export const StyledModalContent = styled(ModalContent)`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;

  & button {
    margin: 8px;
  }
`;
